import { d as r } from "../internals/define-built-in.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { t as n } from "../internals/to-string.js";
import { v as a } from "../internals/validate-arguments-length.js";
var e = URLSearchParams,
  i = e.prototype,
  s = t(i.getAll),
  o = t(i.has);
new e("a=1").has("a", 2) && r(i, "has", function (r) {
  var t = arguments.length,
    e = t < 2 ? void 0 : arguments[1];
  if (t && void 0 === e) return o(this, r);
  var i = s(this, r);
  a(t, 1);
  for (var f = n(e), l = 0; l < i.length;) if (i[l++] === f) return !0;
  return !1;
}, {
  enumerable: !0,
  unsafe: !0
});